import { RotatingLoadingMessagesProvider } from '@components/rotating-loading-messages';
import { useLocalStorageTheme, useThemeSyncer } from '@components/theme-provider';
import { TooltipStyles } from '@components/tooltip';
import { DatePickerStyles } from '@styles/datepicker';

import { QueryClientProvider } from 'api/query-client';
import { RouterProvider } from 'ui/router';

export const App = () => {
  const { storedTheme } = useLocalStorageTheme('journeys');
  useThemeSyncer(storedTheme);

  return (
    <QueryClientProvider>
      <RotatingLoadingMessagesProvider>
        <RouterProvider />
        <DatePickerStyles />
        <TooltipStyles />
      </RotatingLoadingMessagesProvider>
    </QueryClientProvider>
  );
};
